<template>
  <main class="main customer_benefits" role="main">
    <div class="main_con">
      <div class="con_ttl top10">{{ section.name }}</div>
      <div class="list_top bot24">
        <div
          class="sort"
          v-if="
            (benefits.content && benefits.content.length > 0) ||
              benefits.length > 0
          "
        >
          <ul>
            <li
              class="pnt"
              :class="{ on: filter.orderType == 'CREATED_AT_DESC' }"
              @click="closeBenefitFilterModal('CREATED_AT_DESC')"
            >
              <p>최신 순</p>
            </li>
            <li
              class="pnt"
              :class="{ on: filter.orderType == 'CREATED_AT_ASC' }"
              @click="closeBenefitFilterModal('CREATED_AT_ASC')"
            >
              <p>오래된 순</p>
            </li>
            <li
              class="pnt"
              :class="{ on: filter.orderType == 'STORE_COUNT' }"
              @click="closeBenefitFilterModal('STORE_COUNT')"
            >
              <p>매장 많은 순</p>
            </li>
          </ul>
        </div>
        <button class="btn_refresh" @click.prevent="refresh"></button>
      </div>
      <div class="gift_list">
        <!-- keyword_benefit 요청 -->
        <benefitDetail
          v-for="(benefit, i) in benefits.content || benefits"
          :key="i"
          :benefit="benefit"
          @select="goShop"
        />
        <div
          class="empty_wrap"
          v-if="
            fetchCompleted &&
              ((benefits.content && benefits.content.length == 0) ||
                benefits.length == 0)
          "
        >
          <div class="empty result">
            <!--'기본: ', '준비중: ready', '결과없음: result'-->
            <div class="msg">
              <div>등록된 키워드 혜택이 없습니다</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BenefitFilterModal
      v-if="benefitFilterModal"
      @close="closeBenefitFilterModal"
      :filter="filter"
    />
  </main>
</template>

<script>
import benefitDetail from '@/common/components/keyword/BenefitDetail.vue';
import BenefitFilterModal from './modal/BenefitFilterModal.vue';
import {
  mapActions,
  mapState,
  mapGetters,
  mapMutations,
} from '@common/store/modules/keyword';
import * as keywordTypes from '@common/store/modules/keyword/types';
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';
export default {
  components: { benefitDetail, BenefitFilterModal },
  data() {
    return {
      fetchCompleted: false,
      benefitFilterModal: false,
      options: {
        orderType: 'CREATED_AT_DESC',
      },
      filter: {},
    };
  },
  beforeCreated() {
    this.filter = this.options;
  },
  async mounted() {
    this.filter = this.options;
  },
  async beforeRouteEnter(to, from, next) {
    return next(async vm => {
      await vm.fetch();
    });
  },
  computed: {
    ...mapGetters({
      section: keywordTypes.SECTION,
      benefits: keywordTypes.BENEFITS,
    }),
    ...userMapGetters({
      userInfo: userTypes.USER,
    }),
  },
  methods: {
    ...mapActions([
      keywordTypes.FETCH_STORE_KEYWORD,
      keywordTypes.FETCH_BENEFITS,
    ]),
    ...mapMutations([keywordTypes.SET_BENEFIT, keywordTypes.RESET_BENEFIT]),
    openBenefitFilterModal(type) {
      this.benefitFilterModal = true;
    },
    closeBenefitFilterModal(orderType) {
      this.options.orderType = orderType;
      this.filter = this.options;
      this.benefitFilterModal = false;
      this.fetch();
    },
    refresh() {
      this.filter = this.options;
      this.fetch();
    },
    fetch() {
      this[keywordTypes.RESET_BENEFIT]();
      const param = {
        //emdAreaId: this.userInfo.emdAreaId,
        userId: this.userInfo.id,
        keywordId: this.section.id,
        orderType: this.filter.orderType,
      };
      //this[keywordTypes.FETCH_STORE_KEYWORD](param);
      this[keywordTypes.FETCH_BENEFITS](param);
      this.fetchCompleted = true;
    },
    goShop(evt, data) {
      this[keywordTypes.SET_BENEFIT](data);
      this.$router.push({
        name: 'keyword.shop',
        query: {
          title: this.section.name,
        },
      });
    },
  },
};
</script>
